<template>
	<div>
		<div>
			<ul class="sm-list">
				<li class="sm-li" v-for="(row, index) in rows" :key="row[index]" :class="currentIndex == index ? 'current' : ''">
					<a v-if="! showFull( index )" href="#" class="sm-edit sm-edit-flat sm-eye" :title="collapseTitle" @click.prevent="collapseRow(index)">
						<span class="icon-eye"></span>
					</a>
					<a href="#" class="sm-edit sm-edit-flat" :title="editTitle" @click.prevent="editRow(index)"><span class="icon-pencil"></span></a>
					<a href="#" class="sm-delete sm-delete-flat" :title="deleteTitle" @click.prevent="deleteRow(index, false)">
						<span class="icon-cancel sm-lg"></span>
					</a>
					<div class="sm-flex sm-flex-justify-start">
    					<div v-if="row.title" class="sm-flex-full-no-padding sm-italic" style="padding-bottom: 3px;color: #3498db;font-weight: bold;">{{ row.title }}</div>
    					<span class="name" :class="{ required : row.checkbox }">{{ row.name }}</span> <span class="sm-sep">:</span>
    					<div v-if="showFull( index )" v-html="calculateValue( row.value, index )"></div>
    					<div v-else><div class="sm-arg-block"><span class="value params">{...}</span></div></div>
    					<div v-if="hasRadios" class="sm-arg-param-desc">{{ row.radio ? radios[row.radio] : radios[0] }}</div>
    					<div v-if="row.desc" class="sm-flex-full-no-padding sm-italic" style="padding-top: 3px;">{{ row.desc }}</div>
					</div>
				</li>
			</ul>
			<p v-if="hasControls">Edit current parameter:</p>
			<input v-if="hasExtendedControls" style="max-width: 506px;" class="sm-large sm-mb10" type="text" ref="inputTitle" :placeholder="titlePlaceholder" v-model="titleInput" @keydown="errorShow = false">
			<textarea class="sm-tinymce-field-input" style="max-width: 506px" v-if="hasExtendedControls" type="text" ref="inputDesc" :placeholder="descPlaceholder" v-model="descInput" @keydown="errorShow = false"></textarea>
			<input v-if="hasControls" type="text" ref="inputName" :placeholder="namePlaceholder" v-model="nameInput" @keydown="errorShow = false">
			<input v-if="hasControls" type="text" ref="inputValue" :placeholder="valuePlaceholder" v-model="valueInput" @keydown="errorShow = false">
			<div v-if="hasRadios" class="sm-radio-wrapper">
				<div v-if="radioDesc" class="sm-mr10 sm-mb10">{{ radioDesc }}</div>
				<div v-for="(radio, id_radio) in radios" :key="radios[id_radio]" style="margin-bottom:3px">
				    <input class="sm-radio" type="radio" :value="id_radio" :id="'sm_radio_' + componentId + '_' + id_radio" v-model="radioInput">
				    <label :for="'sm_radio_' + componentId + '_' + id_radio">
				    <span>{{ radio }}</span><a v-if="tooltips[id_radio]" href="javascript:void(0);" data-placement="right" rel="tooltip" class="sm-info" :title="tooltips[id_radio]"><span class="icon-info"></span></a>
				    </label>
				</div>
			</div>
			<p v-if="hasCheckbox" class="sm-required-wrapper">
				<span v-if="checkboxDesc" class="sm-mr10">{{ checkboxDesc }}</span>
			    <input class="sm-checkbox" type="checkbox" id="sm_checkbox_0" v-model="checkboxInput">
			    <label for="sm_checkbox_0">
			    </label><a v-if="checkboxTooltip" data-placement="bottom" href="javascript:void(0);" rel="tooltip" class="sm-info" :title="checkboxTooltip"><span class="icon-info"></span></a>
			</p>
		</div>
		<button v-if="hasControls" type="button" class="sm-button sm-edit-button" @click="addRow">
			<i class="icon-plus"></i><span v-if="editMode">{{ editTitle }}</span><span v-else="editMode">{{ addTitle }}</span> {{ buttonTitle }}
		</button>
		<transition name="fade">
			<span class="sm-error" v-if="errorShow">{{ errorMsg }}</span>
		</transition>
		<input v-if="hasInputs" type="hidden" :name="rowsId()" :value="inputValues()">
	</div>
</template>

<script>
import bus from './Bus.js';
export default {
	props: {
		componentId: String,
		metaType: String,
		titlePlaceholder: String,
		descPlaceholder: String,
		namePlaceholder: String,
		valuePlaceholder: String,
		buttonTitle: String,
		def: {
			type: Array,
			default: function() {
				return [];
			}
		},
		radios: {
			type: Array,
			default: function() {
				return [];
			}
		},
		tooltips: {
			type: Array,
			default: function() {
				return [];
			}
		},
		radioDesc: String,
		checkboxDesc: String,
		checkboxTooltip: String,
		rows: Array,
		needValue: {
			type: Boolean,
			default: false
		},
		hasInputs: {
			type: Boolean,
			default: true
		},
		hasControls: {
			type: Boolean,
			default: true
		},
		hasExtendedControls: {
			type: Boolean,
			default: false
		},
		hasRadios: {
			type: Boolean,
			default: false
		},
		hasCheckbox: {
			type: Boolean,
			default: false
		},
		booleans: {
			type: Boolean,
			default: false
		},
	},
	data: function() {
		return {
			showIndex: [],
			editMode: false,
			init: true,
			addTitle: sm.addTitle,
			editTitle: sm.editTitle,
			deleteTitle: sm.deleteTitle,
			collapseTitle: sm.collapseTitle,
			emptyTitle: sm.emptyTitle,
			titleInput: '',
			descInput: '',
			nameInput: '',
			valueInput: '',
			radioInput: '0',
			currentIndex: null,
			checkboxInput: '',
			errorMsg: '',
			errorShow: false
		};
	},
	mounted: function() {
		jQuery(document).ready(function($) {
			$('.sm-info').tooltip({
		        placement: $(this).attr('data-placement'),
		        html: true,
		        viewport: { selector: 'body', padding: 0 },
		        template: '<div class="sm-tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
		    });
		});
		this.$emit('rows', this.def);
		var self = this;
		bus.$on('focus', function(id) {
			if (self.componentId == id) {
				self.$refs.inputName.focus();
			}
		});
		bus.$on('checkMethod', function(id, method) {
			if (self.componentId == id) {
				for (var i = 0, len = self.rows.length; i < len; i++) {
					if (self.rows[i].name == method) {
						self.$emit('edit', self.rows[i]);
					}
				}
			}
		});
		bus.$on('fullDic', function(id, rows) {
			if (self.componentId == id) {
				self.showIndex.splice(0, self.showIndex.length);
				for (var i = 0; i < rows.length; i++) {
					for (var g = 0; g < self.rows.length; g++) {
						if (self.rows[g].name == rows[i].name) {
							self.deleteRow(g, true);
						}
					}
					if (rows[i].value.length > 0) {
						self.rows.push({
    						title: rows[i].title,
    						desc: rows[i].desc,
							name: rows[i].name.toLowerCase(),
							value: rows[i].value,
							radio: rows[i].radio,
							checkbox: rows[i].checkbox,
						});
					}
				}
				self.init = false;
                for (var i = 0; i < self.rows.length; i++) {
                    if (i != self.rows.length - 1) {
		                var val;
						try {
							val = JSON.parse(self.rows[i].value);
							if (typeof val == 'object') {
								self.showIndex.push(i);
							}
						} catch (e) {}
                	}
                }
				self.titleInput = self.descInput = self.valueInput = self.valueInput = '';
				self.radioInput = '0';
				self.checkboxInput = '';
                self.currentIndex = null;
				self.$emit('changed', self.rows);
			}
		});
	},
	methods: {
		rowsId: function() {
			return this.metaType + 's';
		},
		inputValues: function() {
			return JSON.stringify(this.rows);
		},
		addRow: function() {
			if (this.validate()) {
				if (!this.editMode) {
					this.rows.push({
    					title: this.titleInput,
    					desc: this.descInput,
						name: this.nameInput.toLowerCase(),
						value: this.valueInput,
						radio: this.radioInput,
						checkbox: this.checkboxInput
					});
				} else {
    				this.rows[this.currentIndex].title = this.titleInput;
    				this.rows[this.currentIndex].desc = this.descInput;
					this.rows[this.currentIndex].name = this.nameInput.toLowerCase();
					this.rows[this.currentIndex].value = this.valueInput;
					this.rows[this.currentIndex].radio = this.radioInput;
					this.rows[this.currentIndex].checkbox = this.checkboxInput;
					this.editMode = false;
				}
				this.titleInput = this.descInput = this.nameInput = this.valueInput = '';
				this.radioInput = '0';
				this.checkboxInput = '';
				this.currentIndex = null;
				this.$refs.inputName.focus();
				this.$emit('changed', this.rows);
			}
		},
		deleteRow: function(index, notClickEvent) {
			this.init = true;
			if (!notClickEvent) {
				this.$emit('delete', this.rows[index]);
			}
			this.rows.splice(index, 1);
			if (this.hasControls) {
				this.titleInput = this.descInput = this.nameInput = this.valueInput = '';
				this.radioInput = '0';
				this.checkboxInput = '';
				this.$refs.inputName.focus();
			}
			this.currentIndex = null;
			this.editMode = false;
			this.$emit('changed', this.rows);
		},
		editRow: function(index) {
			this.currentIndex = index;
			this.editMode = true;
			if (this.hasControls) {
    			this.titleInput = this.rows[index].title;
    			this.descInput = this.rows[index].desc;
				this.nameInput = this.rows[index].name;
				this.valueInput = this.rows[index].value;
				this.radioInput = this.rows[index].radio;
				this.checkboxInput = this.rows[index].checkbox;
				this.$refs.inputName.focus();
			}
			this.$emit('edit', this.rows[index]);
		},
		collapseRow: function(index) {
			this.init = false;
			this.showIndex.splice(this.showIndex.indexOf(index), 1);
		},
		calculateValue: function(value, index) {
			var self = this;
			var val;
			try {
				val = JSON.parse(value);
				var temp = '';
				var count = 0;
				if (typeof val == 'object') {
					for (var item in val) {
						if (val.hasOwnProperty(item)) {
							temp += '<div class="sm-arg-block first-level"><div><span class="sm-array-key">' + item + '</span>' + '<span class="sm-query-sep sm-query-sep-arrow sm-query-sep-key"></span></div><div>' + self.recurringValue(val[item]) + '</div></div>';
						}
						count++;
					}
					val = temp;
					if (self.init) self.showIndex.push(index);
					return val;
				}
			} catch (e) {}
			if ( value.length != 0 ) {
				val = '<span class="value params">' + value + '</span>';
			} else {
				val = '<span class="empty-value">' + this.emptyTitle + '</span>';
			}
			return val;
		},
		showFull: function(index) {
			if (this.showIndex.indexOf(index) != -1) return false;
			return true;
		},
		recurringValue: function(value) {
			var self = this;
			var val = '<span class="value">' + value + '</span>';
			if (typeof value == 'object') {
				var temp = '';
				var count = 0;
				for (var item in value) {
					if (value.hasOwnProperty(item)) {
						temp += '<div class="sm-arg-block sm-arg-array';
						if (count == 0) temp += ' first';
						if (count == Object.keys(value).length - 1 ) temp += ' last';
						temp += '"><div><span class="sm-query-sep sm-query-sep-arrow sm-query-sep-key"></span><span class="sm-array-key">' + item + '</span>' + '<span class="sm-query-sep sm-query-sep-arrow sm-query-sep-key"></span></div><div>' + self.recurringValue(value[item]) + '</div></div>';
					}
					count++;
				}
				val = temp;
			}
			return val;
		},
		error: function(type) {
			this.errorShow = false;
			this.$refs.inputName.focus();
			switch (type) {
				case 'badInput':
					this.errorMsg = sm.errorBadInput;
					break;
				case 'duplicates':
					this.errorMsg = sm.errorDuplicates;
					break;
				default:
					this.errorMsg = sm.errorDefault;
					break;
			}
			this.errorShow = true;
		},
		validate: function() {
			var valid = true;
			var title = this.titleInput;
			var desc = this.descInput;
			var name = this.nameInput;
			var value = this.valueInput;
			var error = this.error;
			var reg = /^([a-zA-Z0-9-_]*|{\[[a-zA-Z0-9_| '"(),]*\]})$/;
			var reg2 = /^([a-zA-Z0-9-_ ]*|{\[[a-zA-Z0-9_| '"(),]*\]})$/;
			if (name !== "") {
				if (value === "" && this.needValue) {
					error('badInput');
					return false;
				}
				if (!reg.test(name)) {
					error('badInput');
					valid = false;
				}
				if (!reg2.test(title)) {
					error('badInput');
					valid = false;
				}
				if (!reg2.test(desc)) {
					error('badInput');
					valid = false;
				}
				if (!this.editMode) {
					this.rows.filter(function(row) {
						if (row.name == name) {
							error('duplicates');
							valid = false;
						}
					});
				}
				if ( this.booleans ) {
					if ( ( value === "" || value === 'false' ) && this.radioInput == '1') { 
						this.valueInput = 'false'; 
					} else if (value !== "" && this.radioInput == '1') this.valueInput = 'true';
				}
			} else {
				valid = false;
			}
			return valid;
		}
	}
};
</script>


// WEBPACK FOOTER //
// Dictionary.vue?00c93670